import { render } from "./PhoneCode.vue?vue&type=template&id=c6662ce4&scoped=true"
import script from "./PhoneCode.vue?vue&type=script&lang=js"
export * from "./PhoneCode.vue?vue&type=script&lang=js"

import "./PhoneCode.vue?vue&type=style&index=0&id=c6662ce4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6662ce4"]])

export default __exports__